import { useContext } from "react";
import { Form } from "react-bootstrap";

import { DataFormFieldContext } from "../../contexts/dataFormFieldContext";
import { InfoToolTip } from "../infoToolTip";

export const FormFieldTitle = () => {
	const {
		isVerticalLayout,
		fieldSetting: { title = "", tooltip = null },
	} = useContext(DataFormFieldContext);

	if (isVerticalLayout)
		return (
			<Form.Label data-testid="test-formFieldTitle">
				{title} {tooltip ? <InfoToolTip tooltip={tooltip} /> : null}
			</Form.Label>
		);

	return (
		<Form.Label column sm={3} data-testid="test-formFieldTitle">
			{title} {tooltip ? <InfoToolTip tooltip={tooltip} /> : null}
		</Form.Label>
	);
};
